import { api } from "./api";
import type { Order, OrderItemInput } from "./procurement";

export interface ConstructionMaterial {
  id: string; naziv: string; jedinica_mjere: OrderItemInput["jedinica"];
  aktivan: boolean; redoslijed: number; ima_toleranciju: boolean;
}
export interface DeliveryProtocol {
  razlog: "manjak" | "visak" | "odbijeno" | "drugo"; tekst: string;
  inzenjer: string; poslovodja: string; vozac: string;
}
export interface ConstructionOverview {
  gradiliste: string; mjesec: string | null;
  zbir: { materijal_id: string; naziv: string; jedinica: string; kolicina: string; razredi: Record<string, string> }[];
  narudzbe: Order[];
}
const root = "/nabava";
export const construction = {
  materials: async (signal?: AbortSignal) => (await api.get<ConstructionMaterial[]>(`${root}/gradilisni-materijali`, { signal })).data,
  saveMaterial: async (input: Omit<ConstructionMaterial, "id">, id?: string) =>
    (await (id ? api.put<ConstructionMaterial>(`${root}/gradilisni-materijali/${id}`, input) : api.post<ConstructionMaterial>(`${root}/gradilisni-materijali`, input))).data,
  policy: async (signal?: AbortSignal) => (await api.get<{ nabava_tolerancija_betona_posto: string }>(`${root}/gradilisni-postavke`, { signal })).data,
  savePolicy: async (value: string) => (await api.patch(`${root}/gradilisni-postavke`, { nabava_tolerancija_betona_posto: value })).data,
  close: async (id: string, zapisnik?: DeliveryProtocol, photo?: File | null) => {
    if (!photo) return (await api.post<Order>(`${root}/narudzbe/${id}/zatvori-isporuku`, { zapisnik: zapisnik ?? null })).data;
    const body = new FormData(); body.set("podaci", JSON.stringify({ zapisnik: zapisnik ?? null })); body.append("fotka", photo, photo.name);
    return (await api.post<Order>(`${root}/narudzbe/${id}/zatvori-isporuku`, body)).data;
  },
  overview: async (site: string, month: string, signal?: AbortSignal) => (await api.get<ConstructionOverview>(`${root}/gradilista/${site}/gradilisni-pregled`, { signal, params: month ? { mjesec: month } : {} })).data,
};
export const unitLabel = (unit: string) => ({ m3: "m³", m2: "m²" } as Record<string, string>)[unit] ?? unit;
